import $axios from './config'
import Login from './login'
import Info from './info'
import PostForm from './postForm'


class Api {
  constructor($axios = {}) {
    this.$axios = $axios
  }
  get login() {
    const login = Login(this.$axios)
    return {
      ...login
    }
  }
  get info() {
    const info = Info(this.$axios)
    return {
      ...info
    }
  }

  get postForm() {
    const postForm = PostForm(this.$axios)
    return {
      ...postForm
    }
  }

}

export default new Api($axios)